'use strict';

module.exports = {
  mustAdd: 'MustAdd',
  mustRemove: 'MustRemove',
  optionalAdd: 'OptionalAdd',
  optionalRemove: 'OptionalRemove',
  blank: '',
};
